const decodeFilterValue = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const parseMultiValueFilter = (value?: string | null): string[] => {
  if (!value) {
    return [];
  }

  return value
    .split(',')
    .map(item => decodeFilterValue(item).trim())
    .filter(Boolean);
};

export const serializeMultiValueFilter = (values: readonly string[]): string =>
  values
    .map(value => value.trim())
    .filter(Boolean)
    .map(encodeURIComponent)
    .join(',');

export const appendUniqueMultiValueFilter = (currentValue: string | null | undefined, nextValue: string): string => {
  const normalizedNextValue = nextValue.trim();

  if (!normalizedNextValue) {
    return serializeMultiValueFilter(parseMultiValueFilter(currentValue));
  }

  const currentValues = parseMultiValueFilter(currentValue);

  if (currentValues.includes(normalizedNextValue)) {
    return serializeMultiValueFilter(currentValues);
  }

  return serializeMultiValueFilter([...currentValues, normalizedNextValue]);
};
